import { useEffect, useState } from "react";
import useTurno from "../../../../../core/hooks/use-turno";
import { toast } from "../../../../../core/helpers/message-helper";
import { selectTurnosSedes } from "../../../../NominaTurnos/services/nomina-turnos-service";
import ContainerOpciones from "../ContainerOpciones/container-opciones";

const OpcionesTurnos = () => {
    const [opcionesTurnos, setOpcionesTurnos] = useState([]);
    const { obtenerTurnosSeleccionados, actualizarTurnos } = useTurno();

    useEffect(async () => {
        const resp = await selectTurnosSedes();
        if (!resp.status) return toast.error(resp.message);
        setOpcionesTurnos(resp.data);
    }, []);

    const onBuscar = (evento) => {
        const busquedaSigla = evento.target.value ?? "";
        const opcionesTurnos = document.querySelectorAll(
            ".opciones .lista-opciones-turnos .opcion-turno"
        );
        opcionesTurnos.forEach((opcion) => {
            const { sigla } = opcion.dataset;
            if (!sigla.includes(busquedaSigla.toUpperCase())) {
                opcion.style.display = "none";
            } else {
                opcion.style.display = "";
            }
        });
    };

    const onClickOpcion = async (turnoNuevo) => {
        const turnosACambiar = obtenerTurnosSeleccionados();
        actualizarTurnos(turnoNuevo, turnosACambiar);
    };

    return (
        <ContainerOpciones
            tipo="turnos"
            onBuscar={onBuscar}
            opciones={opcionesTurnos.map((turno) => {
                return (
                    <li
                        onClick={() => onClickOpcion(turno)}
                        key={turno.id}
                        className="opcion-turno"
                        data-sigla={turno.sigla}
                    >
                        {turno.info_asignacion_turno}
                    </li>
                );
            })}
        />
    );
};

export default OpcionesTurnos;
